import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SiguientesPasosResponse } from 'src/app/global/interfaces/siguientes-pasos-response';
import { SiguientesPasosService } from 'src/app/global/services/siguientes-pasos.service';
import { SiguientesPasosServiceVM } from 'src/app/view-model/services/siguientes-pasos-vm.service';


@Injectable()
export class SiguientesPasosProviderVM extends SiguientesPasosServiceVM {

    constructor(private sigPasosService: SiguientesPasosService) {
        super();
    }

    obtenerSiguientesPasos(): Observable<SiguientesPasosResponse> {
        return this.sigPasosService.obtenerSiguientesPasos()
            .pipe(map(this.pasosOK), catchError(this.errorResponse));
    }

    private pasosOK(response) {
        return response;
    }

    private errorResponse(error) {
        return throwError(error);
    }
}
